import {IResource} from '@simpli/resource-collection/dist/types/IResource'

export class OrbitLeaderboardEntry implements IResource {
  address: string | null = null
  totalTxs: number = 0
  poolParticipations: number = 0
  poolClaims: number = 0
  totalGasRewards: number = 0

  get $id() {
    return 0
  }

  get $tag() {
    return String(this.$id)
  }
}
